"use strict";
exports.__esModule = true;
var CssHelpers = /** @class */ (function () {
    function CssHelpers() {
    }
    CssHelpers.getTranslateX = function (value) {
        value = Math.round(value);
        return "translateX(" + value + "px) translateZ(0)";
    };
    CssHelpers.getTranslateXScaleX = function (translateValue, scaleValue) {
        translateValue = Math.round(translateValue);
        scaleValue = Math.round(scaleValue * 1000) / 1000;
        return "translateX(" + Math.round(translateValue) + "px) translateZ(0) scaleX(" + scaleValue + ")";
    };
    CssHelpers.rgbToHex = function (colorValueRgb) {
        var cached = CssHelpers.rgbToHexCache[colorValueRgb];
        if (cached == null) {
            cached = ('0' + parseInt(colorValueRgb.toString(), 10).toString(16).toUpperCase()).slice(-2);
            CssHelpers.rgbToHexCache[colorValueRgb] = cached;
        }
        return cached;
    };
    CssHelpers.hexToRgb = function (colorValueHex) {
        var cached = CssHelpers.hexToRgbCache[colorValueHex];
        if (cached == null) {
            cached = parseInt(colorValueHex.substr(1, 2), 16) + ", " + parseInt(colorValueHex.substr(3, 2), 16) + ", " + parseInt(colorValueHex.substr(5, 2), 16);
            CssHelpers.hexToRgbCache[colorValueHex] = cached;
        }
        return cached;
    };
    CssHelpers.getColorString = function (rgbColor, opacity) {
        return "rgba(" + rgbColor + ", " + opacity + ")";
        ;
    };
    CssHelpers.getColorStringFromHex = function (rgbColorInHex, opacity) {
        return CssHelpers.getColorString(CssHelpers.hexToRgb(rgbColorInHex), opacity);
    };
    CssHelpers.rgbToHexCache = {};
    CssHelpers.hexToRgbCache = {};
    return CssHelpers;
}());
exports.CssHelpers = CssHelpers;
//# sourceMappingURL=css-helpers.js.map